export const darkTheme = {
  bg: "#000A14", 
  bgLight: "#1A1A1A",
  primary: "#007BFF",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#181818",
  card_light: "#1B1B1D",
  button: "linear-gradient(135deg, #00aaff 0%, #0056b3 100%)",
  button_hover: "linear-gradient(135deg, #0056b3 0%, #003f7f 100%)",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#E3F2FD",
  primary: "#007BFF",
  text_primary: "#111111",
  text_secondary: "#48494a",
  card: "#FFFFFF",
  button: "linear-gradient(135deg, #00aaff 0%, #0056b3 100%)",
  button_hover: "linear-gradient(135deg, #0056b3 0%, #003f7f 100%)",
};
